import { Backdrop, CircularProgress, Modal } from "@mui/material";
import { UniEditorSmall } from "@unisearch/common/form";
import API from "@unisearch/helpers/api";
import { Form, Formik } from "formik";
import { useRouter } from "next/router";
import { useState } from "react";
import { FiX } from "react-icons/fi";
import { IoMdMail } from "react-icons/io";
import * as Yup from "yup";
import { v4 as uuidv4 } from "uuid";
import styles from "./actions.module.scss";
import { swalError, swalSuccess } from "@unisearch/helpers";

export const ConversationAction = ({ email, ...props }) => {
  const [conLoading, setConLoading] = useState(false);
  const [conversationModal, setConversationModal] = useState(false);
  const [conversationUniqueId, setConversationUniqueId] = useState();

  // Validation schema
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email()
      .required("Select an email"),
    message: Yup.string()
      .required("Write Message")
      .typeError("Write Message"),
    subject: Yup.string().required("Write something in subject box"),
  });

  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setConversationModal(false);
  };

  // draft mail
  const handleDraftMail = async (values) => {
    const payload = {
      message: values.message,
      receiverEmail: values.email,
      subject: values.subject,
      parentMessageId: 0,
    };
    if (values.subject && values.email) {
      await API.post(
        `/student/conversation/conversation/draft/${conversationUniqueId}`,
        payload
      ).then((res) => {
        if (!res.error) {
        }
      });
    }
  };
  const storeMail = async (values) => {
    setConLoading(true);
    const payload = {
      message: values.message,
      receiverEmail: values.email,
      subject: values.subject,
      parentMessageId: 0,
    };
    if (values.subject && values.email) {
      await API.post(
        `/student/conversation/conversation/draft/${conversationUniqueId}`,
        payload
      ).then(async (res) => {
        if (!res.error && res.statusCode === 201) {
          const payload = {
            message: values.message,
            receiverEmail: values.email,
            subject: values.subject,
            parentMessageId: 0,
          };
          await API.post(
            `/student/conversation/conversation/send/${conversationUniqueId}`,
            payload
          ).then(async (res) => {
            if (!res.error) {
              swalSuccess("Email Sent");
              setConLoading(false);
              setConversationModal(false);
            } else if (res.error && res.message) {
              swalError(res.message);
              setConLoading(false);
            } else {
              swalError("something went wrong");
              setConLoading(false);
            }
          });

          setConLoading(false);
        } else {
          swalError(res.message);
        }
      });
    }
  };

  const renderComponent = () => {
    return (
      <div className={`${styles.connect_wrapper}  relative`}>
        <IoMdMail
          onClick={() => {
            setConversationModal(true);
            setConversationUniqueId(uuidv4());
          }}
        />
        <div className={`uni-tooltip`}>Conversation</div>
        <Modal
          open={conversationModal}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div className="modal md">
            <div className="modal_head">
              <h4 className="modal_title">New Mail</h4>
              <button
                className="cross_icon"
                onClick={() => {
                  setConversationModal(false);
                  setConversationUniqueId();
                }}
              >
                <FiX />
              </button>
            </div>

            <div
              className="modal_body"
              style={{
                padding: "20px",
              }}
            >
              <Formik
                initialValues={{
                  email: email,
                  subject: "",
                  message: "",
                  parentMessageId: 0,
                }}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  storeMail(values);
                }}
              >
                {({ handleSubmit, setFieldValue, values, errors, touched }) => {
                  return (
                    <Form className="form">
                      <div className="admin_drawer_container">
                        <div className="admin_drawer_body_outer">
                          <div
                            className="admin_drawer_body"
                            style={{
                              height: "100%",
                            }}
                          >
                            <div className={styles.reply_box_wrapper}>
                              <div className={`reply_box`}>
                                <div className={styles.reply_box_to}>
                                  <span>To</span>
                                  <div
                                    className={`reply_box_subject ${styles.reply_box_subject}`}
                                  >
                                    <div
                                      className="admin_form_group"
                                      style={{
                                        marginBottom: "0px",
                                      }}
                                    >
                                      <input
                                        style={{
                                          borderRadius: "0",
                                          border: "0",
                                        }}
                                        type="email"
                                        disabled
                                        className={
                                          errors.email && touched.email
                                            ? `admin_input error_box`
                                            : `admin_input`
                                        }
                                        placeholder={
                                          errors.email && touched.email
                                            ? errors.email
                                            : "Write a user email"
                                        }
                                        onChange={(e) => {
                                          handleChange(e.target.value);
                                          setFieldValue(
                                            "email",
                                            e.target.value
                                          );
                                        }}
                                        value={values.email ? values.email : ""}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`reply_box_subject ${styles.reply_box_subject}`}
                                >
                                  <div
                                    className="admin_form_group"
                                    style={{
                                      marginBottom: "0px",
                                    }}
                                  >
                                    <input
                                      style={{
                                        borderRadius: "0",
                                        borderLeft: "0",
                                        borderRight: "0",
                                      }}
                                      onBlur={(e) => {
                                        handleDraftMail(values);
                                      }}
                                      type="text"
                                      className={
                                        errors.subject && touched.subject
                                          ? `admin_input error_box`
                                          : `admin_input`
                                      }
                                      placeholder={
                                        errors.subject && touched.subject
                                          ? errors.subject
                                          : "Write a subject line"
                                      }
                                      onChange={(e) => {
                                        setFieldValue(
                                          "subject",
                                          e.target.value
                                        );
                                      }}
                                      value={
                                        values.subject ? values.subject : ""
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="reply_box_texteditor">
                                <UniEditorSmall
                                  onChange={(e) => {
                                    setFieldValue("message", e.target.value);
                                  }}
                                  contents={
                                    values.message ? values.message : ""
                                  }
                                  onBlur={(e) => {
                                    handleDraftMail(values);
                                  }}
                                />
                              </div>
                            </div>
                            {errors.message && touched.message && (
                              <div className="invalid-feedback">
                                {errors.message}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="modal_footer">
                        <div className={`btn_group ${styles.btn_group}`}>
                          <button
                            className="btn btn-cancel btn btn-md"
                            onClick={() => {
                              setConversationModal(false);
                              setConversationUniqueId();
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleSubmit}
                            type="submit"
                            className="btn btn-secondary btn-md"
                          >
                            {conLoading && (
                              <CircularProgress size="16px" color="inherit" />
                            )}
                            Send
                          </button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </Modal>
      </div>
    );
  };

  if (typeof window !== "undefined") {
    return renderComponent();
  } else {
    return false;
  }
};

export default ConversationAction;
